export enum LineJoin {
    Round = "Round",
    Bevel = "Bevel",
    Miter = "Miter"
}